<template>
  <div id="pie-chart">
    <apexchart
      type="pie"
      width="380"
      :options="chartOptions"
      :series="series"
      class="has-padding-1"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "pie-chart",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    finalTotal: {
      type: Number,
      default: 0,
    },
    costSectionTotals: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    series() {
      return this.costSectionTotals.map(costSectionTotal => {
        const percentage = (costSectionTotal / this.finalTotal) * 100;
        return Math.round(percentage);
      });
    },
    chartOptions() {
      return {
        labels: [
          "Prevention",
          "Appraisal",
          "Internal Failure",
          "External Failure",
          "Other",
        ],
        dataLabels: {
          enabled: false,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                show: false
              },
            },
          },
        ],
        legend: {
          position: "right",
          offsetY: 0,
          height: 230,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return `${val} %`;
            },
          },
        },
      };
    },
  },
};
</script>
